module.exports = __webpack_public_path__ + "img/icon-discord-gray.4ad1d2fe.svg";